module.exports = __webpack_public_path__ + "static/media/dungeon.098cf78c.svg";